const methods = {
  isEmptyArray: (value) => {
    console.log(value)
    for (let i = 0; i < value.length; i++) {
      if (value[i] === '' || value[i] === null || value[i] === undefined) {
        return true
      }
    }
    return false
  },
  getContentsCountArray: () => {
    
    const arr = []
    for (let i = 1; i <= 50; i++) {
      const j = {}
      j.label = `${i}개`
      j.value = i
      arr.push(j)
    }
    return arr
  }
}

export default {
  install (Vue) {
    Vue.prototype.$isEmptyArray = methods.isEmptyArray
    Vue.prototype.$getContentsCountArray = methods.getContentsCountArray
  }
}